import React from 'react';
import PropTypes from 'prop-types';
import css from './ContactSection.scss';
import Title from '../../common/Title';
import { SFEntityID } from 'utils/types';

export default class ContactSection extends React.Component {

  get email() {
    const { email } = this.props;
    return email ? <a href={`mailto:${email}`}>Send an email</a> : null;
  }

  get phone() {
    const { phoneNumber } = this.props;
    return phoneNumber ? <a href={`tel:${phoneNumber}`}>Call {phoneNumber}</a> : null;
  }

  get url() {
    const { url } = this.props;
    return url ? <a href={url}>Visit website</a> : null;
  }

  get smartThinkingLink() {
    return this.props.isSmartLinkVisible ?
      <a href={`../serviceCatalog/smarthinkingLTI.html?partyId=${this.props.serviceId}`} rel="noopener noreferrer"
         target="_blank">Launch Smarthinking</a>
      : null;
  }

  render() {
    return (
      <div>
        <Title text="Contact" />
        <div className={css['contact-container']}>
          {this.smartThinkingLink}
          {this.email}
          {this.phone}
          {this.url}
        </div>
      </div>
    );
  }
}

ContactSection.propTypes = {
  url: PropTypes.string,
  phoneNumber: PropTypes.string,
  email: PropTypes.string,
  serviceId: SFEntityID,
  isSmartLinkVisible: PropTypes.bool
};
